import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Panel } from 'primereact/panel';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { FormRow } from '../../components/Atoms/Form';

const ReportDialog = ({ onHide }) => {
  return (
    <Dialog
      onHide={onHide}
      modal
      breakpoints={{ '960px': '90vw' }}
      header={'보고서'}
      visible
      style={{ width: '76vw' }}
      footer={() => (
        <div className="flex flex-auto align-items-start justify-content-start pt-2">
          <Button label="완료" className="mr-1" />
        </div>
      )}
    >
      <Panel header="보고서 작성" className="pt-3 cm-search-panel">
        <div className="grid">
          <div className="col-12">
            <FormRow label="보험사 선택" labelCol="col-2" inputCol="col-3">
              <Dropdown optionLabel="name" className="w-full" />
            </FormRow>

            <FormRow label="증권번호" labelCol="col-2" inputCol="col-3">
              <InputText className="w-full" />
            </FormRow>

            <FormRow label="상담내용" labelCol="col-2" inputCol="col">
              <InputText className="w-full" />
            </FormRow>

            <FormRow label="수리품목" labelCol="col-2" inputCol="col">
              <InputText className="w-full" />
            </FormRow>

            <FormRow label="손해액" labelCol="col-2" inputCol="col-3">
              <InputText className="w-full" />
            </FormRow>

            <FormRow label="자기부담금" labelCol="col-2" inputCol="col-3">
              <InputText className="w-full" />
            </FormRow>

            <FormRow label="연락처" labelCol="col-2" inputCol="col-3">
              <InputText className="w-full" />
            </FormRow>

            <FormRow label="작성자" labelCol="col-2" inputCol="col-3" noMargin>
              <InputText className="w-full" />
            </FormRow>
          </div>
        </div>
        <Divider />
        <div className="flex justify-content-end mt-4 gap-2">
          <Button label="자부담금 통보" className="p-button-outlined mr-1" />
          <Button label="보고서 보내기" className="mr-1" />
        </div>
      </Panel>
    </Dialog>
  );
};

export default ReportDialog;
